export default class CustomersController {
    /** @ngInject */
    constructor(CustomersApi, Loader, DialogService, $timeout) {
        this.CustomersApi = CustomersApi;
        this.Loader = Loader;
        this.DialogService = DialogService;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.customers = [];
        this.selectedCustomers = [];

        this.query = '';

        this.inProgress = false;

        this.loadCustomers();
    }

    startProgress() {
        this.inProgress = true;
        this.Loader.show();
    }

    stopProgress() {
        this.inProgress = false;
        this.Loader.hide();
    }

    loadCustomers(query) {
        this.startProgress();

        let promise;
        if (query && query.length) {
            promise = this.CustomersApi.search(query);
        } else {
            promise = this.CustomersApi.getList();
        }

        return promise.then((data) => {
            this.customers = data.customers || [];

            this.stopProgress();

            return this.customers;
        }, () => {
            this.customers = [];

            this.stopProgress();

            return this.customers;
        });
    }

    onSearch({ query }) {
        this.query = query;

        this.loadCustomers(query);
    }

    resetSearch() {
        this.query = '';

        this.loadCustomers();
    }

    onCustomerDelete(customer) {
        this.startProgress();

        this.CustomersApi.deactivateCustomer(customer.id).then(() => {
            this.customers = this.customers.filter(localCustomer => localCustomer.id !== customer.id);
            this.stopProgress();
            // TODO: refactor when elastic will work correctly with cache
            // this.loadCustomers();
        }, () => {
            this.stopProgress();
        });
        // TODO: add toast for error
    }

    onCustomerResetPassword(customer) {
        this.startProgress();

        this.CustomersApi.resetPasswordForCustomer(customer.id).then(() => {
            this.stopProgress();
            // TODO: refactor when elastic will work correctly with cache
            // this.loadCustomers(); // should we?
        }, () => {
            this.stopProgress();
        });
        // TODO: add toast for error
    }

    onRequestAccess($event, customer) {
        this.DialogService.prompt({
            title: 'Request access to view customer info',
            htmlContent: `This will send a message to ${customer.email}<br />
                            asking them to click a link to allow you full access to<br />
                            their account and sensors for 72 hours.<br /><br />
                            
                            You will be notified when you have access or if they<br />
                            deny your request.<br /><br />
                            
                            You can add a personalized message below<br />
                            (optional).`,
            placeholder: 'Personal message',
            ariaLabel: 'request-access-to-view-info',
            targetEvent: $event,
            ok: 'Request access',
            cancel: 'Cancel'
        }).then((message = '') => {
            this.startProgress();

            this.CustomersApi.requestAccessToCustomer({ customer_id: customer.id, message }).then(() => {
                // TODO: refactor when elastic will work correctly with cache
                this.$timeout(() => {
                    this.loadCustomers();
                }, 1000);
            }, () => {
                this.stopProgress();
            });
            // TODO: add toast for error
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/users-and-access/customers/customers.controller.js